export const showcaseFormatsUpdated = [
  {
    id: "carousel-ads",
    slug: "carousel-ads",
    name: "Carousel Ads",
    typeFormat: "image",
    preview: "/assets/showcase/CarouselAds.png",
    platformPreviewLink: "https://creativepreview.flashtalking.net/pv/UHHym_g06WltrFO",
    category: "Rich Media",
    description: "Allows displaying multiple images and/or videos in a single ad, each with its own headline, description, link, and CTA.",
    specs: ["Multiple slides", "Individual CTA per slide", "Swipe on mobile and navigation on desktop"],
    docUrl: "https://support.flashtalking.com/hc/en-us/articles/4410779419155-Carousel-Ads-Overview",
    certified: true,
    note: ""
  },
  {
    id: "communicating-ads",
    slug: "communicating-ads",
    name: "Communicating Ads",
    typeFormat: "interactive",
    preview: "/assets/showcase/CommunicatingAds.png",
    platformPreviewLink: "https://creativepreview.flashtalking.net/p/NgpNn4wT0rWMn6",
    category: "Rich Media",
    description: "Two or more ads on a page that interact with each other, triggering animations or expansions.",
    specs: ["Ad-to-ad communication", "Event-based interactions"],
    docUrl: "https://support.flashtalking.com/hc/en-us/articles/4410699107731-Communicating-Ads-Overview",
    certified: true,
    note: ""
  },
  {
    id: "footer-ads",
    slug: "footer-ads",
    name: "Footer Ads",
    typeFormat: "image",
    preview: "/assets/showcase/StandardAds_AND_TapToCallAds_AND_FooterAds_AND_OnpageAds.png",
    platformPreviewLink: "https://creativepreview.flashtalking.net/p/pohDCh41EyMDva",
    category: "Rich Media",
    description: "Ads fixed to the bottom of the screen with a close button to remove the ad.",
    specs: ["Screen-bottom placement", "Close button"],
    docUrl: "https://support.flashtalking.com/hc/en-us/articles/4410775222035-Footer-Ads-Overview",
    certified: true,
    note: ""
  },
  {
    id: "lightbox-ads",
    slug: "lightbox-ads",
    name: "Lightbox Ads",
    typeFormat: "interactive",
    preview: "/assets/showcase/LightboxAds.png",
    platformPreviewLink: "https://creativepreview.flashtalking.net/p/5oo25356Eyt55w",
    category: "Rich Media",
    description: "Interactive ads designed to quickly capture attention using multiple images or videos.",
    specs: ["Multi-asset experience", "High-impact engagement"],
    docUrl: "https://support.flashtalking.com/hc/en-us/articles/4410783403283-Lightbox-Ads-Overview",
    certified: true,
    note: ""
  },
  {
    id: "map-and-store-locator-ads",
    slug: "map-and-store-locator-ads",
    name: "Map and Store Locator Ads",
    typeFormat: "interactive",
    preview: "/assets/showcase/store-locator.png",
    platformPreviewLink: "",
    category: "Rich Media",
    description: "Ads that include interactive maps and store locations powered by data feeds.",
    specs: ["Interactive map", "Store locator integration"],
    docUrl: "https://support.flashtalking.com/hc/en-us/articles/4411099241875-Map-and-Store-Locator-Ads-Overview",
    certified: true,
    note: ""
  },
  {
    id: "share-tweet-ads",
    slug: "share-tweet-ads",
    name: "Share Tweet Ads",
    typeFormat: "interactive",
    preview: "/assets/showcase/ShareTweetAds.png",
    platformPreviewLink: "https://creativepreview.flashtalking.net/p/5ooOi451EltBYW",
    category: "Social",
    description: "Allows users to post a message and link directly to their Twitter account from the ad.",
    specs: ["Twitter integration", "One-click sharing"],
    docUrl: "https://support.flashtalking.com/hc/en-us/articles/4411615027219-Special-Formats-Overview",
    certified: true,
    note: ""
  },
  {
    id: "sidebar-ads",
    slug: "sidebar-ads",
    name: "Sidebar Ads",
    typeFormat: "image",
    preview: "/assets/showcase/SitebarAds.png",
    platformPreviewLink: "https://creativepreview.flashtalking.net/p/pHaUI2U6EJv2I5",
    category: "Rich Media",
    description: "Large, responsive ads placed to the right of publisher content with a sticky effect.",
    specs: ["Sticky positioning", "Responsive layout"],
    docUrl: "https://support.flashtalking.com/hc/en-us/articles/4411621173907-Sitebar-Ads-Overview",
    certified: true,
    note: ""
  },
  {
    id: "dynamic-ads",
    slug: "dynamic-ads",
    name: "Dynamic Ads",
    typeFormat: "interactive",
    preview: "/assets/showcase/DynamicAndFeedAds.png",
    platformPreviewLink: "",
    category: "Dynamic",
    description: "Ads powered by instantAds that adapt in real time based on contextual data.",
    specs: ["instantAds", "Geo, weather, and time targeting", "Real-time personalization", "Scalable creative variations"],
    docUrl: "https://support.flashtalking.com/hc/en-us/articles/4410387258003-Dynamic-Ads-Overview",
    certified: true,
    note: ""
  },
  {
    id: "feed-ads",
    slug: "feed-ads",
    name: "Feed Ads",
    typeFormat: "interactive",
    preview: "/assets/showcase/DynamicAndFeedAds.png",
    platformPreviewLink: "",
    category: "Dynamic",
    description: "Ads that leverage live data feeds to display up-to-date and personalized content.",
    specs: ["Live data feeds", "Dynamic content updates"],
    docUrl: "https://support.flashtalking.com/hc/en-us/articles/4410387258003-Dynamic-Ads-Overview",
    certified: true,
    note: ""
  },
  {
    id: "standard-ads",
    slug: "standard-ads",
    name: "Standard Ads",
    typeFormat: "image",
    preview: "/assets/showcase/StandardAds_AND_TapToCallAds_AND_FooterAds_AND_OnpageAds.png",
    platformPreviewLink: "",
    category: "Basic",
    description: "Simple ads with basic functionality and a single click tag.",
    specs: ["Single click tag", "No video or dynamic content"],
    docUrl: "https://support.flashtalking.com/hc/en-us/sections/115001622527-Standard-Ads",
    certified: true,
    note: ""
  },
  {
    id: "richload-ads",
    slug: "richload-ads",
    name: "Richload Ads",
    typeFormat: "interactive",
    preview: "/assets/showcase/RichloadAds.png",
    platformPreviewLink: "",
    category: "Rich Media",
    description: "Ads that load additional content after initial load to comply with polite loading rules.",
    specs: ["Base + richload files", "Polite loading compliant"],
    docUrl: "https://support.flashtalking.com/hc/en-us/articles/4410663889811-Richload-Ads-Overview",
    certified: true,
    note: ""
  },
  {
    id: "expand-ads",
    slug: "expand-ads",
    name: "Expand Ads",
    typeFormat: "interactive",
    preview: "/assets/showcase/ExpandAds.png",
    platformPreviewLink: "",
    category: "Rich Media",
    description: "Ads that expand beyond their original size based on user interaction.",
    specs: ["Click or hover expansion", "Close button"],
    docUrl: "https://support.flashtalking.com/hc/en-us/articles/4410657528339-Expand-Ads-Overview",
    certified: true,
    note: ""
  },
  {
    id: "vast-ads",
    slug: "vast-ads",
    name: "VAST Ads",
    typeFormat: "video",
    preview: "/assets/showcase/VastAds.mp4",
    platformPreviewLink: "https://creativepreview.flashtalking.net/pv/abcd1234",
    category: "Video",
    description: "IAB-standard format for delivering video ads using VAST XML.",
    specs: ["IAB compliant", "Video player compatible"],
    docUrl: "https://support.flashtalking.com/hc/en-us/articles/4411060005011-VAST-Ads-Overview",
    certified: true,
    note: ""
  },
  {
    id: "fullscreen-autoclose",
    slug: "fullscreen-autoclose",
    name: "Full-Screen Auto-Close (Splash)",
    typeFormat: "video",
    preview: "/assets/showcase/FullScreenAutoClose__Splash.mp4",
    platformPreviewLink: "https://creativepreview.flashtalking.net/p/NjmAyeryijkA7e",
    category: "Demo",
    description: "Full-screen ad with a button to close it automatically.",
    specs: [
      "1300x2390px image",
      "Button to automatically close after 5 seconds",
      "Interactive close button with hover and scale effect",
      "Clicking the background triggers clickTag",
      "Background image zoom animation using TweenMax",
      "Desktop compatible (auto-expand enabled for testing)"
    ],
    certified: true,
    note: "No image, placeholder gray"
  },
  {
    id: "responsive-carousel",
    slug: "responsive-carousel",
    name: "Responsive Carousel",
    typeFormat: "interactive",
    preview: "/assets/showcase/RBS_ResponsiveCarousel.png",
    platformPreviewLink: "https://creativepreview.flashtalking.net/p/Mgp4lyCnEkW4O7",
    category: "Demo",
    description: "Manual DCO format with products, images, and text. Users can interact with product information and click through to retailer links.",
    specs: [
      "Product images 100x100px",
      "Product title",
      "Short product description",
      "Short CTA text",
      "Supports multiple products and interactive navigation"
    ],
    certified: false,
    note: ""
  },
  {
    id: "shoppable-dco",
    slug: "shoppable-dco",
    name: "Shoppable DCO",
    typeFormat: "video",
    preview: "/assets/showcase/ShoppableDCO.mp4",
    platformPreviewLink: "https://creativepreview.flashtalking.net/p/Mmpka-cfW3kcaPf",
    category: "Demo",
    description: "Dynamic Creative Optimization (DCO) format featuring one main product and up to three retailers. Users can view prices, discounts, and make purchases directly via interactive click-throughs.",
    specs: [
      "General: Main product image",
      "General: Up to three retailer logos and individual pricing",
      "General: Short product title and description",
      "General: Discounts displayed when applicable",
      "General: Interactive Buy CTA button for each retailer",
      "General: Fade-in animation from step image to full creative",
      "General: Supports multiple dimensions: 300x250, 300x600, 320x480",
      "Technical: Developed using Flashtalking HTML5 API",
      "Technical: Interactive carousel controlled via ft-carousel",
      "Technical: Supports autorotate and touch gestures for multiple products",
      "Technical: Dynamic click-through applied per product based on stock availability",
      "Technical: Responsive design to adapt to various creative dimensions"
    ],
    certified: false,
    note: ""
  },
  {
    id: "shoppable-dco-rappi",
    slug: "shoppable-dco-rappi",
    name: "Shoppable DCO - Rappi",
    typeFormat: "video",
    preview: "/assets/showcase/ShoppableDCORappi.mp4",
    platformPreviewLink: "https://creativepreview.flashtalking.net/pv/YcuqewE8yKFpFo",
    category: "Demo",
    description: "Dynamic Creative Optimization (DCO) format featuring one main product and up to three retailers. Users can view prices, discounts, and make purchases directly via interactive click-throughs.",
    specs: [
      "Main product image",
      "Up to three retailer logos and individual pricing",
      "Short product title and description",
      "Discounts displayed when applicable",
      "Interactive Buy CTA button for each retailer",
      "Fade-in animation from step image to full creative",
      "Supports multiple dimensions: 300x250, 300x600, 320x480"
    ],
    certified: false,
    note: ""
  },
  {
    id: "shoppable-dco-cerveza",
    slug: "shoppable-dco-cerveza",
    name: "Shoppable DCO - Cerveza",
    typeFormat: "video",
    preview: "/assets/showcase/ShoppableDCOCerveza.mp4",
    platformPreviewLink: "https://creativepreview.flashtalking.net/pv/YcuqewE8yKFpFo",
    category: "Demo",
    description: "Dynamic Creative Optimization (DCO) format featuring different products. Users can view prices, discounts, and make purchases directly via interactive click-throughs.",
    specs: [
      "Main product image",
      "Up to three retailer logos and individual pricing",
      "Short product title and description",
      "Discounts displayed when applicable",
      "Interactive Buy CTA button for each retailer",
      "Fade-in animation from step image to full creative",
      "Supports multiple dimensions: 300x250, 300x600, 320x480"
    ],
    certified: false,
    note: ""
  },
  {
    id: "interactive-product-selector",
    slug: "interactive-product-selector",
    name: "Interactive Product Selector",
    typeFormat: "video",
    preview: "/assets/showcase/InteractiveCarSelector.mp4",
    platformPreviewLink: "https://creativepreview.flashtalking.net/p/GpjwvsGjSWctas",
    category: "Demo",
    description: "Explore multiple product variations—colors, models, or styles—in a single interactive banner with smooth animations and detail-focused zoom.",
    specs: [
      "General: Main image with large product and 4 clickable options",
      "General: Supports multiple variations (colors, models, styles)",
      "General: Reusable and scalable template structure",
      "General: Easily adaptable to other products or formats",
      "Technical: Interactive image swapping with smooth animation",
      "Technical: Localized zoom effect to highlight product details",
      "Technical: PNG assets with transparency support",
      "Technical: Developed in Flashtalking using HTML5 and custom interactivity"
    ],
    certified: false,
    note: ""
  },
  {
    id: "dvast-overlay",
    slug: "dvast-overlay",
    name: "DVAST Video with Overlay",
    typeFormat: "video",
    preview: "/assets/showcase/DVASTVideoWithOverlay.mp4",
    platformPreviewLink: "https://creativepreview.flashtalking.net/pv/2hhlfvmZrWCl7M",
    category: "Demo",
    description: "DVAST video ad format where dynamic elements like background color, logo, images, titles, descriptions, and CTAs appear over the video while it continues playing, enhancing engagement and allowing personalized messaging.",
    specs: [
      "MP4 video format",
      "Dynamic overlays: background color, logo, images, title, description, CTA",
      "Elements appear during video playback",
      "Supports personalized messaging and engagement optimization",
      "Developed using AdStudio DCO or manual animation"
    ],
    certified: false,
    note: ""
  },
  {
    id: "dco",
    slug: "dco",
    name: "DCO - Dynamic Creative",
    typeFormat: "interactive",
    preview: "/assets/showcase/DCO_version.png",
    platformPreviewLink: "https://creativepreview.flashtalking.net/pv/GjpcHRicigkk_R",
    category: "Demo",
    description: "DCO format created using a drag-and-drop platform, allowing multiple versions of the creative to be automatically generated by dynamically changing text, images, and other elements, ideal for personalized campaigns and optimized engagement.",
    specs: [
      "Built using platform's drag-and-drop DCO tool",
      "Dynamic elements include text, images, and CTAs",
      "Generates multiple creative variations automatically",
      "Supports personalized campaigns and A/B testing",
      "Delivered as a standard HTML5 ad"
    ],
    certified: false,
    note: ""
  },
  {
    id: "vast-companion-ads",
    slug: "vast-companion-ads",
    name: "VAST Video + Companion Ads",
    typeFormat: "video",
    preview: "",
    platformPreviewLink: "",
    category: "Demo",
    description: "VAST video format that delivers static companion ads alongside the main video. Designed to extend campaign reach with complementary visuals while keeping the video file lightweight and efficient.",
    specs: [
      "MP4 video max size: 10 MB",
      "Static companion images (<200 KB each)",
      "Companion images must have exact publication dimensions",
      "Compatible with standard VAST players",
      "Enhances engagement with supplementary visuals"
    ],
    certified: false,
    note: ""
  },
  {
    id: "dvast-dynamic-animation",
    slug: "dvast-dynamic-animation",
    name: "DVAST Video + Dynamic Animation",
    typeFormat: "video",
    preview: "/assets/showcase/DVASTVideoDynamicAnimation.mp4",
    platformPreviewLink: "https://creative-preview.flashtalking.net/p/GgmaG5kWUcfaMd",
    category: "Demo",
    description: "VAST video format featuring a dynamic animation at the end with icons and CTAs, created in AdStudio using DCO templates or manual animation, designed to extend viewer engagement after the main video content.",
    specs: [
      "Video with dynamic animation (fade-in or motion)",
      "Animation duration: approx. 5 seconds",
      "Dynamic icons and clickable CTAs",
      "Developed in AdStudio using DCO templates or manual animation",
      "Engages viewers after the main video content",
      "Delivered as a single VAST tag combining video and animation"
    ],
    certified: false,
    note: ""
  },
  {
    id: "interactive-video-carousel",
    slug: "interactive-video-carousel",
    name: "Interactive Video + Product Carousel",
    typeFormat: "video",
    preview: "/assets/showcase/InteractiveVideo_ProductCarousel.mp4",
    platformPreviewLink: "https://creativepreview.flashtalking.net/p/Mmj1vHMNgWW1aS",
    category: "Demo",
    description: "Interactive vertical video with a product carousel showcasing images, prices, descriptions, and clickable links, designed to engage users and drive conversions.",
    specs: [
      "Vertical video 383x679px",
      "Video cover image 383x679px",
      "Interactive product carousel over video",
      "Product images",
      "Product prices",
      "Product descriptions",
      "Clickable URLs for each product",
      "Navigation via hover, click, or touch",
      "Autoplay disabled; user controls engagement"
    ],
    certified: false,
    note: ""
  },
  {
    id: "footer-touchpoint-ad",
    slug: "footer-touchpoint-ad",
    name: "Footer Touchpoint Ad",
    typeFormat: "video",
    preview: "/assets/showcase/footerAd.mp4",
    platformPreviewLink: "https://creativepreview.flashtalking.net/p/Mgm1xWk75cfRDW",
    category: "Demo",
    description: "Expandable footer ad with a striking background, fixed while scrolling, featuring a customizable CTA and close button to engage users instantly.",
    specs: [
      "Desktop dimensions: 1920x100px",
      "Mobile dimensions: 430x140px",
      "Safe area: Desktop 740px (left), Mobile 280px (left)",
      "Cut area: Desktop 1180px (right), Mobile 150px (right)",
      "Customizable CTA text (max 10 characters) and color",
      "CTA text color can be chosen for contrast",
      "Background image with logo recommended on left side",
      "Ad remains fixed at the bottom while scrolling",
      "Close button included"
    ],
    certified: false,
    note: "Certification not accepted by Globo"
  },
  {
    id: "expandable-pip",
    slug: "expandable-pip",
    name: "Expandable + PiP",
    typeFormat: "video",
    preview: "/assets/showcase/Expandable_PiP.mp4",
    platformPreviewLink: "https://creativepreview.flashtalking.net/p/Nggz0dVVEkW8_O",
    category: "Demo",
    description: "Expandable rich media format that auto-expands on load, displaying a full visual experience. When closed or timed out, the ad transitions into a Picture-in-Picture (PiP) reminder that stays visible on screen, reinforcing the message without interrupting the user experience.",
    specs: [
      "Auto-expand on load (desktop)",
      "Expandable container with background image or video",
      "Smooth animation on expand",
      "User-initiated close button",
      "Automatic timeout to close expanded ad",
      "Picture-in-Picture (PiP) displayed after close or timeout",
      "Dynamic PiP sizing based on image ratio and viewport",
      "Animated PiP entrance",
      "Independent close button on PiP",
      "Clickable background with clickTag support",
      "Flashtalking HTML5 API compatible"
    ],
    certified: false,
    note: "High-impact format with persistent visibility via PiP."
  },
  {
    id: "dynamic-fluid-gallery",
    slug: "dynamic-fluid-gallery",
    name: "Dynamic Fluid Gallery",
    typeFormat: "gif",
    preview: "/assets/showcase/dynamic_fluid_gallery_600x400.gif",
    platformPreviewLink: "",
    category: "Demo",
    description: "Interactive dynamic banner displaying multiple products with prices. Users can scroll or swipe through items, click on any product to navigate to its landing page, and view real-time updates of promotions and availability. Engages users directly with the brand while showcasing a range of products dynamically.",
    specs: [
      "Dynamic product carousel banner",
      "Displays product images, names, and prices",
      "Clickable products with clickTag support",
      "Automatic or manual scrolling through items",
      "Supports touch and mouse interactions",
      "Animated transitions between products",
      "Optional real-time product updates",
      "Flashtalking HTML5 API compatible"
    ],
    certified: false,
    note: "High-impact interactive format encouraging user engagement."
  },
  {
    id: "interactive-3d-product",
    slug: "interactive-3d-product",
    name: "Interactive 3D Product Banner",
    typeFormat: "gif",
    preview: "/assets/showcase/350x500_anuncio3d.gif",
    platformPreviewLink: "",
    category: "Demo",
    description: "Interactive 3D product banner showcasing a single product (e.g., a sneaker) with a simulated 3D rotation effect using JavaScript. Users can interact with the product, view price, and click to navigate, all while maintaining normal IAB click behavior. Optionally supports DCO for dynamic updates based on user or campaign data.",
    specs: [
      "Interactive 3D product banner",
      "Simulated 3D rotation via JavaScript",
      "Displays product image, name, and price",
      "Clickable with standard IAB clickTag",
      "Smooth animated transitions and rotation easing",
      "Optional dynamic content (DCO) integration",
      "Responsive and works across devices",
      "Flashtalking HTML5 API compatible"
    ],
    certified: false,
    note: "High-impact interactive 3D format designed to increase engagement and highlight individual products."
  },
  {
    id: "football-countdown-banner",
    slug: "football-countdown-banner",
    name: "Football Countdown Banner",
    typeFormat: "gif",
    preview: "/assets/showcase/fifa26_countdown_game.gif",
    platformPreviewLink: "",
    category: "Demo",
    description: "Interactive football banner showing a countdown to a scheduled match (e.g., FIFA26, country vs country). The banner tracks the configured date and time internally, and once the match time is reached, it automatically updates the background and message. No external API connection or live scores are used; all content changes are handled within the banner.",
    specs: [
      "Football match countdown banner",
      "Displays teams and match date/time",
      "Live countdown timer until match start",
      "Automatic content update when match begins based on internal schedule",
      "Dynamic background and messaging on match start",
      "Supports clickTag for promotions or ticket links",
      "Fully self-contained, no external API required",
      "Responsive to desktop and mobile devices",
      "Smooth animations and visual transitions",
      "Flashtalking HTML5 API compatible"
    ],
    certified: false,
    note: "High-engagement format ideal for sports event countdowns, fully self-contained."
  },
  {
    id: "leads-form-banner",
    slug: "leads-form-banner",
    name: "Leads Form Banner",
    typeFormat: "html5",
    preview: "/assets/showcase/leads.gif",
    platformPreviewLink: "",
    category: "Leads",
    description: "Interactive banner focused on lead generation through an embedded form, allowing users to submit their information directly within the ad while sending data in real time to the client’s API.",
    specs: [
      "Lead generation banner with embedded form",
      "Collects user email directly in the banner",
      "Form validation for required fields",
      "Real-time data submission via API endpoint",
      "No data storage on banner provider side",
      "Customizable CTA and messaging",
      "Supports clickTag for fallback navigation",
      "Smooth transitions and user feedback on submit",
      "Flashtalking HTML5 API compatible",
      "Client must provide a working API endpoint to receive form submissions",
      "API must accept at minimum name and email parameters",
      "Endpoint must support CORS for banner requests",
      "Client is fully responsible for data storage and processing"
    ],
    certified: false,
    note: "Ideal for campaigns focused on capturing leads while ensuring full data control remains with the client."
  }
];